import { Component } from '@angular/core';
import { ErrorComponent } from '@atoms/error/error.component';
import { SharedCommonModule } from '../../common.module';

@Component({
  selector: 'edu-url-not-found-page',
  templateUrl: './url-not-found.component.html',
  imports: [SharedCommonModule, ErrorComponent],
})
export class UrlNotFoundPageComponent {}
